import React from "react";
import { Formik, Form } from "formik";
import { TextField, Button, Typography, Grid, Autocomplete } from "@mui/material";
import * as Yup from "yup"; // For form validation
import "./rationale.css";

// Validation schema using Yup
const validationSchema = Yup.object().shape({
  description: Yup.string().required("Description is required").min(10, "Description must be at least 10 characters"),
  reason: Yup.string().required("Reason is required"),
});

const Reasons = ["Reason1", "Reason2", "Reason3"];

const Rationale = ({ updateFormData, nextStep, prevStep }) => {
  return (
    <Formik
      initialValues={{
        reason: "",
        description: "",
      }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        updateFormData({ rationalInfo: values });
        nextStep(); // Move to next form
      }}
    >
      {({ values, handleChange, handleBlur, handleSubmit, errors, touched, setFieldValue }) => (
        <Form onSubmit={handleSubmit} className='form-container'>
          <Typography variant='h6' sx={{ fontWeight: "bold" }} align='left'>
            Rationale For Placement Need
          </Typography>
          <Typography variant='subtitle1' className='form-subtitle' gutterBottom align='left'>
            Explain the reasons why this young person is being considered for <br />
            placement.
          </Typography>
          <Grid container spacing={2} mt={2}>
            <Grid item xs={12} lg={8}>
              <Autocomplete
                id='reason'
                options={Reasons}
                value={values.reason}
                onChange={(event, newValue) => setFieldValue("reason", newValue)}
                renderInput={(params) => (
                  <>
                    <Typography sx={{ fontWeight: "bold" }} align='left'>
                      Select the Resons
                    </Typography>
                    <TextField
                      {...params}
                      placeholder='Select the resons '
                      error={Boolean(touched.reason && errors.reason)}
                      helperText={touched.reason && errors.reason ? errors.reason : ""}
                    />
                  </>
                )}
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={2}>
            <Grid item xs={12} lg={8}>
              <Typography sx={{ fontWeight: "bold" }} align='left'>
                Description of reasons for placement
              </Typography>
              <TextField
                fullWidth
                id='description'
                name='description'
                multiline
                rows={6}
                variant='outlined'
                value={values.description}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.description && Boolean(errors.description)}
                helperText={touched.description && errors.description}
              />
            </Grid>
          </Grid>
          <Grid container justifyContent='space-between' alignItems='center' mt={2}>
            <Grid item>
              <Button type='button' variant='contained' color='primary' onClick={prevStep}>
                Previous
              </Button>
            </Grid>
            <Grid item>
              <Button type='submit' variant='contained' color='primary'>
                Next
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default Rationale;
